<template>
	<div class="box">
		<div class="null-page" v-show="yes"></div>
		
		<el-card class="box-card">
			<div slot="header" class="clearfix">
				<span style="    font-weight: 500;
    font-size: 16px;" >แก้ไขบัญชี</span>
			</div>
		
			<div v-loading="loading">
				<el-form :model="formData" :rules="rules" ref="ruleForm" label-width="80px">
					<el-form-item label="ชื่อ" prop="realname">
						<el-input v-model="formData.realname" placeholder="กรุณาใส่ชื่อจริงของคุณ" class="ns-len-input"></el-input>
					</el-form-item>
		
					<el-form-item label="โทรศัพท์มือถือ" prop="mobile">
						<el-input v-model="formData.mobile" autocomplete="off" placeholder="กรุณากรอกหมายเลขโทรศัพท์ของคุณ" maxlength="11" class="ns-len-input"></el-input>
					</el-form-item>
		
					<el-form-item label="ประเภทบัญชี" prop="withdraw_type">
						<el-select v-model="formData.withdraw_type" placeholder="โปรดเลือกประเภทบัญชี">
							<el-option v-for="(value, key) in transferType" :key="key" :label="value" :value="key" :disabled="key == 'wechatpay'"></el-option>
						</el-select>
					</el-form-item>
		
					<el-form-item label="ชื่อธนาคาร" prop="branch_bank_name" v-if="formData.withdraw_type == 'bank'">
						<el-input v-model="formData.branch_bank_name" autocomplete="off" placeholder="กรุณาใส่ชื่อธนาคาร" maxlength="50" class="ns-len-input"></el-input>
					</el-form-item>
					
					<el-form-item label="ถอนเงินเข้าบัญชีของคุณ" prop="bank_account" v-if="formData.withdraw_type != 'wechatpay' && formData.withdraw_type">
						<el-input v-model="formData.bank_account" autocomplete="off" placeholder="กรุณากรอกบัญชีการถอนเงินของคุณ" maxlength="30" class="ns-len-input"></el-input>
					</el-form-item>
		
					<el-form-item>
						<el-button size="medium" type="primary" @click="saveAccount('ruleForm')" style="    font-family: 'Prompt';"  >บันทึก</el-button>
					</el-form-item>
				</el-form>
			</div>
		</el-card>
	</div>
</template>

<script>
	import { transferType, accountDetail, saveAccount } from "@/api/member/member"
	export default {
		name: "account_edit",
	    components: {},
	    data () {
			let self = this
			var isMobile = (rule, value, callback) => {
			    if (!value) {
			        return callback(new Error("หมายเลขโทรศัพท์ไม่สามารถเว้นว่างได้"))
			    } else {
			        const reg = /((\+66|0)(\d{1,2}\-?\d{3}\-?\d{3,4}))|((\+๖๖|๐)([๐-๙]{1,2}\-?[๐-๙]{3}\-?[๐-๙]{3,4}))/
			
			        if (reg.test(value)) {
			            callback()
			        } else {
			            callback(new Error("โปรดป้อนหมายเลขโทรศัพท์มือถือที่ถูกต้อง"))
			        }
			    }
			}
	        return {
				formData: {
					id: '',
					realname: '',
					mobile: '',
					withdraw_type: '',
					bank_account: '',
					branch_bank_name: ''
				},
				flag: false, //การระบุป้องกันการทําซ้ํา
				payList: [],
				loading: true,
				index: 0,
				transferType: [],
				rules: {
					realname: [{ required: true, message: "กรุณาใส่ชื่อจริงของคุณ", trigger: "blur" }],
					mobile: [{ required: true, validator: isMobile, trigger: "blur" }],
					withdraw_type: [{ required: true, message: 'โปรดเลือกประเภทบัญชี', trigger: 'change' }],
					branch_bank_name: [{ required: true, message: "กรุณาใส่ชื่อธนาคาร", trigger: "blur" }],
					bank_account: [{ required: true, message: "กรุณากรอกบัญชีการถอนเงินของคุณ", trigger: "blur" }],
				},
				yes: true
	        }
	    },
	    created() {
			this.formData.id = this.$route.query.id
			this.getTransferType();
			if (this.formData.id) {
				this.getAccountDetail(this.formData.id)
			}
	    },
		mounted() {
			let self = this;
			setTimeout(function() {
				self.yes = false
			}, 300)
		},
	    methods: {
			/**
			 * รับวิธีการโอน
			 */
			getTransferType() {
				transferType().then(res => {
					this.transferType = res.data;
					
					if (!this.formData.id) { // idว่างเปล่า，นั่นคือการโหลดจะสิ้นสุดที่นี่เมื่อมีการเพิ่ม
						this.loading = false
					}
				}).catch(err => {
					if (!this.formData.id) {
						this.loading = false
					}
				})
			},
			/**
			 * รับรายละเอียดบัญชีของคุณ（แก้ไข）
			 */
			getAccountDetail(id) {
				accountDetail({id: this.formData.id}).then(res => {
					if (res.code == 0 && res.data) {
						this.formData.realname = res.data.realname;
						this.formData.mobile = res.data.mobile;
						this.formData.bank_account = res.data.bank_account;
						this.formData.branch_bank_name = res.data.branch_bank_name;
						this.formData.withdraw_type = res.data.withdraw_type;
					}
					this.loading = false
				}).catch(err => {
					this.loading = false
				})
			},
			/**
			 * ประหยัด
			 */
			saveAccount(formName) {
				this.$refs[formName].validate(valid => {
				    if (valid) {
				        var data = {
							id: this.formData.id,
							realname: this.formData.realname,
							mobile: this.formData.mobile,
							withdraw_type: this.formData.withdraw_type,
							bank_account: this.formData.bank_account,
							branch_bank_name: this.formData.branch_bank_name
				        }
				
				        data.url = "add"
				        if (this.formData.id) {
				            data.url = "edit"
				        }
						
				        if (this.flag) return
				        this.flag = true
				
				        saveAccount(data)
				            .then(res => {
				                if (res.code == 0) {
				                    this.$router.push({ path: "/member/account_list" })
				                } else {
				                    this.flag = false
				                    this.$notify({ message: res.message, title: "คำเตือน",type: "warning" })
				                }
				            })
				            .catch(err => {
				                this.flag = false
				                this.$notify.error({title: 'Error',message: err.message});
				            })
				    } else {
				        return false
				    }
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.box {
		width: 100%;
		position: relative;
	}
	
	.null-page {
		width: 100%;
		height: 730px;
		background-color: #FFFFFF;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 9;
	}
	
	.el-card.is-always-shadow,
	.el-card.is-hover-shadow:focus,
	.el-card.is-hover-shadow:hover {
	    box-shadow: unset;
	}
	
	.el-card {
	    border: 0;
	}
	
	.ns-len-input {
	    width: 350px;
	}
	
	.el-select {
	    margin-right: 10px;
	}
</style>
